const SellingProductData = [{
    "name": "todayData",
    "data": [
        {
            "name": "Samsung Galaxy S8 256GB",
            "price": "$280",
            "sold": 26,
            "revenue": "$536",
            "img": require('../../Image/SamsungGalaxy.png')

        },
        {
            "name": "Half Sleeve Shirt",
            "price": "$39",
            "sold": 80,
            "revenue": "$573",
            "img": require('../../Image/HalfSleeve.png')
        },
        {
            "name": "Marco Shoes",
            "price": "$89",
            "sold": 26,
            "revenue": "$758",
            "img": require('../../Image/MarcosShoe.png')

        },
        {
            "name": "MackBook Pro",
            "price": "$950",
            "sold": 20,
            "revenue": "$154",
            "img": require('../../Image/MacbookPro.png')

        }
    ]
},
{
    "name": "weekData",
    "data": [
        {
            "name": "Samsung Galaxy S8 256GB",
            "price": "$280",
            "sold": 126,
            "revenue": "$38,536",
            "img": require('../../Image/SamsungGalaxy.png'),

        },
        {
            "name": "Half Sleeve Shirt",
            "price": "$39",
            "sold": 180,
            "revenue": "$20,573",
            "img": require('../../Image/HalfSleeve.png')
        },
        {
            "name": "Marco Shoes",
            "price": "$89",
            "sold": 581,
            "revenue": "$170,758",
            "img": require('../../Image/MarcosShoe.png')
        },
        {
            "name": "MackBook Pro",
            "price": "$950",
            "sold": 745,
            "revenue": "$745,154",
            "img": require('../../Image/MacbookPro.png')
        }
    ]
},
{
    "name": "monthData",
    "data": [
        {
            "name": "Samsung Galaxy S8 256GB",
            "price": "$280",
            "sold": 526,
            "revenue": "$78,536",
            "img": require('../../Image/SamsungGalaxy.png'),

        },
        {
            "name": "Half Sleeve Shirt",
            "price": "$39",
            "sold": 680,
            "revenue": "$50,573",
            "img": require('../../Image/HalfSleeve.png')
        },
        {
            "name": "Marco Shoes",
            "price": "$89",
            "sold": 981,
            "revenue": "$570,758",
            "img": require('../../Image/MarcosShoe.png')
        },
        {
            "name": "MackBook Pro",
            "price": "$950",
            "sold": 1045,
            "revenue": "$945,154",
            "img": require('../../Image/MacbookPro.png')
        }
    ]
},
{
    "name": "yearData",
    "data": [
        {
            "name": "Samsung Galaxy S8 256GB",
            "price": "$280",
            "sold": 2026,
            "revenue": "$308,536",
            "img": require('../../Image/SamsungGalaxy.png'),
        },
        {
            "name": "Half Sleeve Shirt",
            "price": "$39",
            "sold": 1180,
            "revenue": "$200,573",
            "img": require('../../Image/HalfSleeve.png')
        },
        {
            "name": "Marco Shoes",
            "price": "$89",
            "sold": 2581,
            "revenue": "$1070,758",
            "img": require('../../Image/MarcosShoe.png')
        },
        {
            "name": "MackBook Pro",
            "price": "$950",
            "sold": 3745,
            "revenue": "$7045,154",
            "img": require('../../Image/MacbookPro.png')
        }
    ]
}
]

export {
    SellingProductData
}